import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import Header from '../../layout/Header';
import Subheader from '../../layout/Subheader';
import api from '../../services/api';
import AnticipationMiddleContent from './RightContent';
import OperationsMiddle from './OperationsMiddle';
import { ConfirmationBox } from '../../components/ConfirmationBox';
import * as S from './styles';
import OperationsLeftContent from './LeftContent';
import { useMessageBox } from '../../context/MessageBox';
import { useNotification } from '../../context/NotificationContext';
import { TOKEN_USER } from '../../services/auth';
import { handleErrorRequest } from '../../utils/errorsValidation';

function AnticipationOperation() {
  let handleTimeout = useRef(null)
  let handleInterval = useRef(null)

  let menus = [];
  let currentMenu;
  try {
    const menuData = JSON.parse(sessionStorage.getItem('@Capitalle-Menu'));
    menus = menuData?.menus || [];
    const currentControler = sessionStorage.getItem('@Capitalle-Current-Menu');
    currentMenu = menus.find((x) => x.menuId == currentControler);
  } catch (e) {
    console.error('Erro ao carregar menus da sessão', e);
  }

  const [destinoPagamentoId, setDestinoPagamentoId] = useState(0)

  const [isTimer, setIsTimer] = useState(false)
  const [agendamentosBackground, setAgendamentosBackground] = useState('red')

  const { setAnchorId } = useNotification();
  const history = useHistory();
  const { setMessageData } = useMessageBox();
  const loginId = JSON.parse(sessionStorage.getItem(TOKEN_USER))?.loginId;
  const [anchors, setAnchors] = useState([]);
  const [selectedAnchor, setSelectedAnchor] = useState(null);
  const [agendamentoModal, setAgendamentoModal] = useState({
    show: false,
    type: '',
    titulo: '',
    htmlText: '',
    callback: () => {},
    labelOptional: '',
    closeBtnLastLayout: true,
    labelClose: ''
  })
  const [selectedProvider, setSelectedProvider] = useState('');
  const [providerInfo, setProviderInfo] = useState([]);
  const [updateRightTable, setUpdateRightTable] = useState({});
  const [proposeProps, setProposeProps] = useState({ isPropose: false, origin: '' });
  const [updateInfo, setUpdateInfo] = useState({ origin: '', id: null, canUpdate: false });
  const [intervalTime, setintervalTime] = useState(0);
  const [opcoesButtons, setOpcoesButtons] = useState({
    nuncaAntecipouQuantidade: '',
    agendadoQuantidade: '',
    de1a30Quantidade: '',
    de31a90Quantidade: '',
    maior90Quantidade: '',
    interesseQuantidade: '',
    corporateQuantidade: ''
  });
  const [updateContent, setUpdateContent] = useState(Date.now());
  const [reloadRightTable, setReloadRightTable] = useState(false);
  const [atualizarAbatimentoDesconto, setAtualizaAbatimentoDesconto] = useState(false)
  const [loadingRight, setLoadingRight] = useState(true)
  const [cargos, setCargos] = useState([])
  const [consultaAgendamento, setConsultaAgendamento] = useState(null)
  const [heightTableAnotacoes, setHeightTableAnotacoes] = useState(0)
  const [heightTableNotas, setHeightTableNotas] = useState(0)
  const [heightTableHistoricos, setHeightTableHistoricos] = useState(0)
  const [boxOperacoes, setBoxOperacoes] = useState([])

  const reloadPage = async (
    provider,
    origemParam = '',
    proposePropsParam = { isPropose: false, origin: '' },
  ) => {
    setTimeout(() => {
      console.log(provider, origemParam, proposePropsParam)
      setSelectedProvider({ ...provider, origemProv: origemParam });
      setProviderInfo(provider);
      setProposeProps(proposePropsParam);
    }, 1);
  };

  const fetchAvailableAnchors = async () => {
    // const message = await api.put('_API/MensagemBoxParametrosDefinidos');
    // setMessageData(message?.data?.complemento?.mensagensBox);
    try {
      const { data } = await api.get(
        `OperacoesAntecipacoes/ConsultarPlataformasAncorasAnalistas?loginId=${loginId}`,
      );
      if (data && data.resposta && data.complemento && data.complemento.codigo !== '204') {
        setAnchors(data.resposta);
        setSelectedAnchor(data.resposta?.[0]);
        setAnchorId(data.resposta?.[0].ancoraId);
        let anchorSelectedId = data.resposta?.[0].ancoraId
        const item = JSON.parse(window.localStorage.getItem('operationFromReport'));
        if (item) {
          window.localStorage.setItem('operationFromReport', null);
          const anchor = data.resposta?.filter((x) => x.ancoraId === item.ancoraId);
          if (anchor.length) {
            setSelectedAnchor(anchor[0]);
          }
          anchorSelectedId = item.ancoraId
          setAnchorId(item.ancoraId);

          let destinoFinal = Number(
            item.destinoPagamentoId ?? item.DestinoPagamentoId ?? 0,
          );

          if (destinoFinal <= 0 && item.antecipacaoId) {
            try {
              const resp = await api.get(
                `Antecipacoes/ConsultarId?id=${item.antecipacaoId}`,
              );
              const antecipacao = Array.isArray(resp?.data?.resposta)
                ? resp.data.resposta[0]
                : resp?.data?.resposta;
              if (antecipacao) {
                destinoFinal = Number(
                  antecipacao.destinoPagamentoId ?? antecipacao.DestinoPagamentoId ?? 0,
                );
              }
            } catch (e) {
              console.error('Fallback: erro ao consultar antecipação para DestinoPagamentoId', e);
            }
          }

          if (destinoFinal <= 0) {
            destinoFinal = Number(sessionStorage.getItem('DestinoPagamentoIdAtual')) || 0;
          }

          if (destinoFinal <= 0) {
            const opMenus = menus.filter((x) => x.controle == 100);
            if (opMenus.length > 0) {
              try {
                const p = JSON.parse(opMenus[0].parametros);
                destinoFinal = Number(p?.DestinoPagamentoId) || 0;
              } catch (e) {
                console.error('Erro ao ler parametros do menu de operações', e);
              }
            }
          }

          if (destinoFinal > 0) {
            sessionStorage.setItem('DestinoPagamentoIdAtual', destinoFinal);
            setDestinoPagamentoId(destinoFinal);
          } else {
            toast.error(
              'Não foi possível determinar o destino de pagamento para esta operação.',
            );
          }

          reloadPage(item, 'PropostasAprovadas');
          setUpdateInfo({
            origin: 'notas-disponiveis',
            id: item.antecipacaoId,
            canUpdate: false,
          });
        }
        consultarAgendamentos(anchorSelectedId)
      } else {
        toast.error('Não foi encontrado nenhuma rede habilitada');
        history.push('/app/home')
      }

    } catch (err) {
      if (err?.response?.data && err?.response?.data?.resposta[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error('Não foi encontrado nenhuma rede habilitada');
      }
      history.push('/app/home')
    }
  };

  const carregarOperacoes = (item) => {
    reloadPage({fornecedorId: item.fornecedorId, valorBruto: item.valorBruto, taxa: item.taxa}, 'Agendamentos');
    setConsultaAgendamento(null)
  }

  const handleOperacoesTimer = (data, timer) => {
    // handleIntervalOperacoes()
    handleTimeout.current = setTimeout(() => {
      setAgendamentoModal({
        titulo: 'Agendamento Pendente',
        htmlText: data.mensagem,
        show: true,
        callback: () => carregarOperacoes(data),
        labelOptional: 'Carregar Operação',
        closeBtnLastLayout: true,
        labelClose: 'Fechar'
      })
      closeTimer()
    }, timer)

  }

  const handleIntervalOperacoes = () => {
    setIsTimer(true)
    handleInterval.current = setInterval(() => {
      let btnAgendamento = document.getElementById('btn-agendamento')
      if(btnAgendamento) {
        if(btnAgendamento.style.backgroundColor == 'rgb(35, 45, 100)') {
          setAgendamentosBackground('red')
        } else {
          setAgendamentosBackground('rgb(35, 45, 100)')
        }
      }
    }, 500)
  }

  const consultarAgendamentos = async (id) => {
    try {
      closeTimer()
      const response = await api.get(`OperacoesAntecipacoes/ConsultarAgendamentos?ancoraId=${id}`)
      if(response.data.status !== 'Inconsistencia' && response.data.complemento.codigo !== '204' && response.data.resposta.ancoraId) {
        setConsultaAgendamento(response.data.resposta)

        if(response.data.resposta.alertaPendente == false && response.data.resposta.contadorSegundos > 0) {
          handleOperacoesTimer(response.data.resposta, response.data.resposta.contadorSegundos * 1000)
        } else {
          handleIntervalOperacoes()
          setAgendamentoModal({
            titulo: 'Agendamento Pendente',
            htmlText: response.data.resposta.mensagem,
            show: true,
            callback: () => carregarOperacoes(response.data.resposta),
            labelOptional: 'Carregar Operação',
            closeBtnLastLayout: true,
            labelClose: 'Fechar'
          })
        }
      } else {
        setConsultaAgendamento(null)
      }
      setMessageData(response?.data?.complemento?.mensagensBox);
    } catch (error) {
      setMessageData(error?.response?.data?.complemento?.mensagensBox);
      handleErrorRequest(error.response);
    }
  }

  const closeTimer = () => {
    setIsTimer(false)
    clearTimeout(handleTimeout.current);
    clearInterval(handleInterval.current)
  }

  const handleSelectAnchor = (anchor) => {
    closeTimer()
    setAnchorId(anchor?.ancoraId);
    setSelectedAnchor(anchor);
    setSelectedProvider('');
    consultarAgendamentos(anchor?.ancoraId)
  };

  const getCargos = async () => {
    try {
      const findCargos = await api.get('Cargos/Consultar?status=Ativo');
      setCargos(findCargos.data.resposta);
    } catch (err) {}
  };

  const getConfigs = async (destinoId, id) => {
    try {
      const configs = await api.get(`OperacoesAntecipacoes/CarregarConfiguracoesTela?destinoPagamentoId=${destinoId}&ancoraId=${id}`);
      if(configs.data?.resposta?.boxPropostas) {
        setBoxOperacoes(configs.data.resposta.boxPropostas)
      }
    } catch (err) {
      console.error('Erro ao carregar configurações da tela', err);
      toast.error('Erro ao carregar configurações da tela de operações.');
    }
  };

  useEffect(() => {
    if (intervalTime > 0) {
      const interval = setInterval(() => setUpdateContent(Date.now()), intervalTime);
      return () => {
        clearInterval(interval);
      };
    }
  }, [intervalTime]);

  useEffect(() => {
    if(destinoPagamentoId && selectedAnchor) {
      getConfigs(destinoPagamentoId, selectedAnchor.ancoraId)
    }
  }, [destinoPagamentoId, selectedAnchor])

  useEffect(() => {
    let initialDestino = 0;

    if (currentMenu) {
      try {
        const parametros = JSON.parse(currentMenu.parametros);
        initialDestino = Number(parametros?.DestinoPagamentoId) || 0;
      } catch (e) {
        console.error('Erro ao ler parametros do menu atual', e);
      }
    }

    if (initialDestino <= 0) {
      initialDestino = Number(sessionStorage.getItem('DestinoPagamentoIdAtual')) || 0;
    }

    if (initialDestino <= 0) {
      const opMenus = menus.filter((x) => x.controle == 100);
      if (opMenus.length === 1) {
        try {
          const p = JSON.parse(opMenus[0].parametros);
          initialDestino = Number(p?.DestinoPagamentoId) || 0;
          if (initialDestino > 0) {
            sessionStorage.setItem('@Capitalle-Current-Menu', opMenus[0].menuId);
          }
        } catch (e) {
          console.error('Erro ao ler parametros do menu de operações', e);
        }
      }
    }

    if (initialDestino > 0) {
      sessionStorage.setItem('DestinoPagamentoIdAtual', initialDestino);
      setDestinoPagamentoId(initialDestino);
    }

    getCargos()
    fetchAvailableAnchors();
    const webSttings = JSON.parse(sessionStorage.getItem('@Capittale-Web-Setting'))
    const heightAnotacoes = webSttings?.configuracoesAmbienteWeb?.find((el) => el.parametroId === 109)?.valor ?? 0
    const heightNotas = webSttings?.configuracoesAmbienteWeb?.find((el) => el.parametroId === 110)?.valor ?? 0
    const heightHistorico = webSttings?.configuracoesAmbienteWeb?.find((el) => el.parametroId === 111)?.valor ?? 0
    setintervalTime(
      Number(
        webSttings?.configuracoesAmbienteWeb?.find((el) => el.parametroId === 40)?.valor ?? 0,
      ) *
      1000 *
      60,
    );

    setHeightTableAnotacoes(Number(heightAnotacoes))
    setHeightTableNotas(Number(heightNotas))
    setHeightTableHistoricos(Number(heightHistorico))
  }, []);

  return (
    <S.Root>
      <Header />
      <Subheader title={currentMenu ? currentMenu.titulo : "Operação de Antecipação"} back="/app/operacao-menu" />
      <S.Content>
        <div>
          {selectedAnchor && (
            <OperationsLeftContent
              anchors={anchors}
              setAtualizaAbatimentoDesconto={setAtualizaAbatimentoDesconto}
              atualizarAbatimentoDesconto={atualizarAbatimentoDesconto}
              handleSelectAnchor={handleSelectAnchor}
              selectedAnchor={selectedAnchor}
              reloadPage={reloadPage}
              updateContent={updateContent}
              updateInfo={updateInfo}
              setUpdateInfo={setUpdateInfo}
              reloadRightTable={reloadRightTable}
              loadingRight={loadingRight}
              boxOperacoes={boxOperacoes}
            />
          )}
        </div>

        <div>
          <OperationsMiddle
            provider={selectedProvider}
            setAtualizaAbatimentoDesconto={setAtualizaAbatimentoDesconto}
            atualizarAbatimentoDesconto={atualizarAbatimentoDesconto}
            setProvider={setSelectedProvider}
            providerInfo={providerInfo}
            setProviderInfo={setProviderInfo}
            anchorId={selectedAnchor?.ancoraId}
            setUpdateRightTable={setUpdateRightTable}
            proposeProps={proposeProps}
            updateInfo={updateInfo}
            setUpdateInfo={setUpdateInfo}
            reloadPage={reloadPage}
            setOpcoesButtons={setOpcoesButtons}
            setReloadRightTable={setReloadRightTable}
            cargos={cargos}
            loginId={loginId}
            heightTableAnotacoes={heightTableAnotacoes}
            heightTableNotas={heightTableNotas}
            heightTableHistoricos={heightTableHistoricos}
            consultarAgendamentos={consultarAgendamentos}
            destinoPagamentoId={destinoPagamentoId}
          />
        </div>

        <div>
          <AnticipationMiddleContent
            anchorId={selectedAnchor?.ancoraId}
            selectedAnchor={selectedAnchor}
            reloadPage={reloadPage}
            updateRightTable={updateRightTable}
            updateInfo={updateInfo}
            setUpdateInfo={setUpdateInfo}
            setOpcoesButtons={setOpcoesButtons}
            opcoesButtons={opcoesButtons}
            reloadRightTable={reloadRightTable}
            setReloadRightTable={setReloadRightTable}
            isLoading={loadingRight}
            setIsLoading={setLoadingRight}
            isTimer={isTimer}
            agendamentosBackground={agendamentosBackground}
          />
        </div>
      </S.Content>
      {agendamentoModal.show && (
        <ConfirmationBox
          data={agendamentoModal}
          setConfirmationBox={setAgendamentoModal}
        />
      )}
    </S.Root>
  );
}

export default AnticipationOperation;
